<template>
  <div id="app" @mousewheel="rollSroll($event)">
    <!-- <Header></Header> -->
    <!-- 轮播图 -->
    <el-carousel
      height="961px"
      direction="vertical"
      :autoplay="false"
      :loop="false"
      indicator-position="none"
      ref="carousel"
      :initial-index="activeIndex"
      @change="changeCarousel"
    >
      <el-carousel-item
        v-for="(item, index) in dataItemInfo"
        :key="index"
        ref="carousel-item"
        :class="{ first: currentIndex === 0, second: currentIndex !== 0 }"
      >
        <AppImg :index="currentIndex" v-if="currentIndex === item.index && currentIndex !==0" :item="item"></AppImg>
      </el-carousel-item>
    </el-carousel>

    <!-- point -->
    <Point
      :activeIndex="activeIndex"
      :PageIndex="currentIndex"
      @childIndex="getChildDdate"
      @childIndex2="getChildPointIndex"
    ></Point>
    <!-- <QRCode v-if="currentIndex === 0"></QRCode> -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Point from "@/components/Point";
import QRCode from "@/components/QRCode";
import Footer from "@/components/Footer";
import AppImg from "@/components/AppImg";
export default {
  created() {
    this.dataItemInfo = [
      {
        index:0,
        name: "",
        imgUrl: "",
        text1: "",
        text2: "",
      },
      {
        index:1,
        name: "运维系统 首页",
        imgUrl: require("@/assets/img/1.png"),
        iconUrl: require('@/assets/img/homeIcon.png'),
        // text1: "发现",
        text2: "实时统计运维人员服务情况，可按天跟踪本周的运维任务，还可及时查看电站告警。",
      },
      {
        index:2,
        name: "运维系统 任务",
        imgUrl:  require("@/assets/img/2.png"),
        iconUrl: require('@/assets/img/taskIcon.png'),
        // text1: "产品",
        text2: "实现现场服务全流程的可视化管理，响应更及时，为客户提供更优质的服务，让客户更满意。",
      },
      {
        index:3,
        name: "运维系统 电站",
        imgUrl:  require("@/assets/img/3.png"),
        iconUrl: require('@/assets/img/powerStationIcon.png'),
        // text1: "电站",
        text2:"查看各个电站的投运状态，以及各个储能设备的运行参数和实时状态。",
          
      },
      {
        index:4,
        name: "运维系统 我的",
        imgUrl:  require("@/assets/img/4.png"),
        iconUrl: require('@/assets/img/myIcon.png'),
        // text1: "电站",
        text2:
          "可查询通用信息，还提供运维知识库、巡检计划、备件库存、服务合同、审批任务等信息管理的入口。"
      }
    ]
  },
  data() {
    return {
      activeIndex: 0,
      currentIndex: 0,
      disabled: false,
      
    };
  },
  components: {
    Header,
    Point,
    QRCode,
    Footer,
    AppImg,
  },
  methods: {
    rollSroll(event) {
      let scrollVal = event.wheelDelta;
      if (scrollVal > 0) {
        this.$refs.carousel.prev();
        // this.currentIndex = this.$refs.carousel.activeIndex;
        console.log("activeIndex==>", this.currentIndex, this.$refs.carousel.activeIndex);
      } else {
        this.$refs.carousel.next();
        console.log("activeIndex==>", this.currentIndex, this.$refs.carousel.activeIndex);
        // this.currentIndex = this.$refs.carousel.activeIndex;
      }
    },

    warnDisabled() {
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 1500);
    },
    getChildDdate(data) {
      console.log('sssssssss+>',data)
      this.$refs.carousel.activeIndex = data;
    },
    getChildPointIndex(index) {
      this.currentIndex = index;
      this.activeIndex = index;
      this.$refs.carousel.activeIndex = index;
    },

    changeCarousel(val) {
      console.log(val);
      this.currentIndex = val;
    },
  },
};
</script>

<style scoped>
.el-carousel {
  position: fixed;
  width: 100%;
  background-size: auto;
  background-repeat: no-repeat;
}
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item.first {
  /* background: url(./assets/img/bg.jpg); */
  /* background: url(./assets/img/bg1.jpg) center no-repeat; */
  background: url(./assets/img/bg.png) ;
  background-position: 0 -35px;
}

.el-carousel__item.second {
  background: url("./assets/img/bgImg.jpg") no-repeat;
}
</style>
